import type { DeepPartial } from '@luna/utils-ts';

import type { AddressBook } from './AddressBook';

export const RO: DeepPartial<AddressBook> = {
    contactDetails: {
        fetchAccountName: true,
    },
    templates: {
        transfer: {
            attributes: [
                'senderName',
                'senderReference',
                'symbols',
                'feeSharingCode',
                'individualConditions',
                'repetitionDays',
                'confirmationEmail',
                'additionalInfo',
                'amount',
                'ro-treasuryInfo',
            ],
        },
    },
    cacheDuration: {
        contact: 10000,
        template: 10000,
        templates: 10000,
        search: 5000,
    },
};
